import { render, staticRenderFns } from "./UDateRangePicker.vue?vue&type=template&id=2e2643fc&"
import script from "./UDateRangePicker.vue?vue&type=script&lang=js&"
export * from "./UDateRangePicker.vue?vue&type=script&lang=js&"
import style0 from "./UDateRangePicker.vue?vue&type=style&index=0&id=2e2643fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports